import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';


import LoginButtons from './login/loginButtons';

import MainPage from './MainPage';
import NaverCallback from './login/naverCallBack';
import FacebookLoginButton from './login/facebookLogin';

const App = () => {
  return (
    <Router basename="/">
      <Routes>
        <Route path="/" element={<LoginButtons />} />
        <Route path="/main" element={<MainPage />} />
        <Route path="/n-auth" element={<NaverCallback />} />
        <Route path="/f-auth" element={<FacebookLoginButton />} />
      </Routes>
    </Router>
  );
};

export default App;

// version: 1
// frontend:
// phases:
// preBuild:
// commands:
// - npm ci--cache.npm--prefer - offline--legacy - peer - deps
// build:
// commands:
// - npm run build
// artifacts:
// baseDirectory: build
// files:
// - '**/*'
// cache:
// paths:
// - .npm/**/ *
